import { render, staticRenderFns } from "./CreateListForm.vue?vue&type=template&id=56fca257&scoped=true&"
import script from "./CreateListForm.vue?vue&type=script&lang=js&"
export * from "./CreateListForm.vue?vue&type=script&lang=js&"
import style0 from "./CreateListForm.vue?vue&type=style&index=0&id=56fca257&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fca257",
  null
  
)

export default component.exports